const transparentBeforeAnimation = (element, timeline) => {
    if (element) {
        timeline.call(() => {
            element.classList.remove('transparent-before-animation');
        }, null);
    }
};

export default transparentBeforeAnimation;
